import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useWorkspaceMode } from "@/lib/workspaceMode";
import { usePlatformDesigner } from "@/lib/usePlatformDesigner";
import { resolveConfiguracionAliasTarget } from "@/modules/config/configuracionRoutes";

/**
 * Alias temporal /configuracion → ruta canónica según contexto (Fase 3E).
 * Preserva query string (?activar_licencia=1, etc.).
 */
export default function ConfiguracionAliasRedirect() {
  const { user } = useAuth();
  const { mode } = useWorkspaceMode();
  const isPlatformDesigner = usePlatformDesigner();
  const location = useLocation();

  const target = resolveConfiguracionAliasTarget({
    mode,
    canGenerateLicenses: user?.can_generate_licenses,
    isPlatformDesigner,
  });

  return <Navigate to={`${target}${location.search || ""}`} replace />;
}
